import Collapsable from "components/Collapsable";
import Content from "components/Content";
import Label from "components/Label";
import React, { FC } from "react";
import { BsFillCheckCircleFill as CircularCheck } from "react-icons/bs";

import styles from "./styles.module.scss";

interface Props {
  title: string;
  benefits: { title: string; description: string; includes: string[] }[];
}

const AdditionalBenefits: FC<Props> = ({ title, benefits }) => {
  return (
    <Content
      contentClassName={styles.container}
      containerClassName={styles.wrapper}
    >
      <Label className={styles.title} variant="h-centered" color="primary">
        {title}
      </Label>
      <div className={styles.benefits}>
        {benefits.map(({ title: benefitTitle, description, includes }) => (
          <Collapsable
            headerClassName={styles.headerWrapper}
            className={styles.benefit}
            withIcon
            iconClassName={styles.benefitIcon}
            header={
              <div className={styles.benefitHeader}>
                <Label
                  variant="h"
                  color="primary"
                  className={styles.headerTitle}
                >
                  {benefitTitle}
                </Label>
                <Label
                  className={styles.headerDescription}
                  variant="s"
                  color="primary"
                >
                  {description}
                </Label>
              </div>
            }
          >
            <div className={styles.includes}>
              {includes.map((item) => (
                <div className={styles.included}>
                  <CircularCheck className={styles.check} />
                  <Label variant="s" color="primary" className={styles.item}>
                    {item}
                  </Label>
                </div>
              ))}
            </div>
          </Collapsable>
        ))}
      </div>
    </Content>
  );
};

export default AdditionalBenefits;
